module.exports = __webpack_public_path__ + "img/gsb30.150505ab.png";